import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axios";
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "../components/PublicPageShell";

const SponsorsList = () => {
  const { pageHeader, isLoading } = usePageHeaderByKey("sponsors");
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance
      .get("/api/sponsors")
      .then((res) => setSponsors(Array.isArray(res.data) ? res.data : []))
      .catch(() => setSponsors([]))
      .finally(() => setLoading(false));
  }, []);

  const openSponsor = (id) => navigate(`/sponsors/${id}`);

  return (
    <PublicPageShell>
      <div className="flex flex-col justify-center w-full">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-2xl mb-6 text-center font-bold text-black uppercase"
        >
          {pageHeader?.h1 || "Our Sponsors"}
        </motion.h1>

        {loading || isLoading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin w-10 h-10 border-2 border-[#BA1500] border-t-transparent rounded-full" />
          </div>
        ) : sponsors.length === 0 ? (
          <p className="text-center text-gray-600 py-12">No sponsors yet.</p>
        ) : (
          <motion.div
            className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 w-full"
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: {
                opacity: 1,
                transition: { staggerChildren: 0.1 },
              },
            }}
          >
            {sponsors.map((sponsor) => (
              <motion.div
                key={sponsor.id}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer border border-gray-100"
                onClick={() => openSponsor(sponsor.id)}
              >
                <p className="font-bold text-lg text-[#BA1500] hover:underline">
                  {sponsor.name}
                </p>
                {sponsor.description && (() => {
                  const plain = sponsor.description.replace(/<[^>]*>/g, "").trim();
                  const preview = plain.length > 120 ? plain.slice(0, 120) + "…" : plain;
                  return <p className="text-gray-600 text-sm mt-2 line-clamp-2">{preview}</p>;
                })()}
              </motion.div>
            ))}
          </motion.div>
        )}
      </div>
    </PublicPageShell>
  );
};

export default SponsorsList;
